import { useState } from 'react';

import useSubscriptionQuery from 'api/queries/useSubscriptionQuery';
import { BenefitsList } from 'features/paid-membership/BenefitsList';
import { JoinModal } from 'features/paid-membership/JoinModal';
import MinusMembershipHeading from 'features/paid-membership/MinusMembershipHeading';
import Button from 'honeydew/Button';
import Card from 'honeydew/Card';
import { useAccountPlusMembershipHook } from 'hooks/useAccountPlusMembershipHook';

/**
 * @param {boolean} [renderCTA=true]
 * @param {'standard' | 'renewal' | 'memberDeals'} [savingsGuaranteeVariant='standard']
 * @returns {JSX.Element}
 */
function BenefitsCard({ renderCTA = true, savingsGuaranteeVariant = 'standard' }) {
    const [showJoinModal, setShowJoinModal] = useState(false);
    const { data: subscriptionData } = useSubscriptionQuery();
    const {
        availableCredits,
        availableTrialMembership,
        hasSavingsGuaranteePerk,
        membership,
        newMemberOffer,
        plusMembershipBranding,
        trial,
    } = useAccountPlusMembershipHook();

    const isPlusMember = membership || trial;
    const showSavingsGuarantee = !isPlusMember || hasSavingsGuaranteePerk;

    return (
        <Card bgColor="bg-plus-membership-gradient">
            <div className="space-y-20">
                {isPlusMember ? (
                    <h3 className="text-heading-xs">Your {plusMembershipBranding} Membership</h3>
                ) : (
                    <MinusMembershipHeading
                        as="h3"
                        className="text-heading-xs"
                        availableCredits={availableCredits}
                        availableTrialMembership={availableTrialMembership}
                        newMemberOffer={newMemberOffer}
                        plusMembershipBranding={plusMembershipBranding}
                        snapExclusive={subscriptionData?.ebtCard?.last4}
                    />
                )}
                <BenefitsList
                    layout="horizontal"
                    bgColor="bg-white"
                    savingsGuaranteeVariant={savingsGuaranteeVariant}
                    showSavingsGuarantee={showSavingsGuarantee}
                />
                {renderCTA && isPlusMember && (
                    <Button as="link" to="/account/membership" size="md" variant="plusMembership">
                        View my membership
                    </Button>
                )}
                {renderCTA && !isPlusMember && (
                    <>
                        <Button as="button" onClick={() => setShowJoinModal(true)} size="md" variant="plusMembership">
                            Learn more
                        </Button>
                        <JoinModal onClose={() => setShowJoinModal(false)} open={showJoinModal} />
                    </>
                )}
            </div>
        </Card>
    );
}

export { BenefitsCard };
